// Update this when tagging a new release.
export const APP_VERSION = "1.0.0";
